import React from 'react';
import PageWrapper from '@repo/ui-components/page-wrapper/PageWrapper';
import FooterColumn from './FooterColumn';
import DownloadsList from './DownloadsList';
import SocialIcons from './SocialIcons';
import LegalFooter from './LegalFooter';
import CustomerCareList from './CustomerCareList';

const Footer = () => (
  <footer className="bg-background mt-auto">
    <PageWrapper $background="inherit">
      <div className="flex flex-col items-stretch justify-center md:flex-row md:flex-wrap">
        <FooterColumn heading="Customer Care">
          <CustomerCareList />
        </FooterColumn>
        <FooterColumn heading="Downloads">
          <DownloadsList />
        </FooterColumn>
        <FooterColumn heading="Find us on">
          <SocialIcons />
        </FooterColumn>
      </div>
      <LegalFooter />
    </PageWrapper>
  </footer>
);

export default Footer;
